/* PARCU - mobile menu rebuilt as large links over a frosted
   sheet.

   The headline collections sit at the top as large links with the
   country and language controls beside them, then each garment
   family as a heading over a two column grid, then everything else
   as a quieter list at the foot.

   Every label is read from the theme's own menu DOM, so nothing is
   hard coded and parcu-i18n.js translates the result along with
   the rest of the page: it walks the whole body on every mutation,
   so the links built here are swapped exactly like the originals.

   The one label that is not lifted verbatim is the headline
   hoodies link, which reads Hoodies rather than Heavyweight
   hoodies. That word is derived instead of translated: the two
   family labels share their adjective and differ in their noun, so
   the noun is whatever the hoodies label does not have in common
   with the tees label. It survives word order (Sweats epais) and
   falls back to the full label when the two do not line up. It is
   recomputed on each pass, so it follows a late translation.

   The original list is left in place and hidden, so if a selector
   ever stops matching the menu underneath still works. */
(function () {
    'use strict';

    var live = null;   /* nodes to keep in step after a late translation */

    function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
    function txt(n) { return n ? n.textContent.trim() : ''; }
    function link(href, label, cls) {
        var a = el('a', cls);
        a.href = href || '#';
        a.textContent = label;
        return a;
    }

    /* The noun that tells the hoodies family apart from the tees. */
    function shortLabel(teeLabel, hoodLabel) {
        if (!teeLabel || !hoodLabel) return hoodLabel || '';
        var wa = teeLabel.split(/\s+/).filter(Boolean);
        var wb = hoodLabel.split(/\s+/).filter(Boolean);
        if (wb.length < 2 || wa.length !== wb.length) return hoodLabel;
        var shared = {}, i;
        for (i = 0; i < wa.length; i++) shared[wa[i].toLowerCase()] = 1;
        var keep = [];
        for (i = 0; i < wb.length; i++) {
            if (!shared[wb[i].toLowerCase()]) keep.push(wb[i]);
        }
        if (!keep.length || keep.length === wb.length) return hoodLabel;
        var s = keep.join(' ');
        return s.charAt(0).toUpperCase() + s.slice(1);
    }

    function topItems(ul) {
        var out = [], lis = ul.children, i, j;
        for (i = 0; i < lis.length; i++) {
            var li = lis[i];
            var det = li.querySelector(':scope > details');
            var head = det ? det.querySelector(':scope > summary a, :scope > summary') : li.querySelector(':scope > a');
            var subs = [];
            if (det) {
                var as = det.querySelectorAll('ul a');
                for (j = 0; j < as.length; j++) subs.push({ href: as[j].getAttribute('href'), label: txt(as[j]) });
            }
            var firstA = li.querySelector('a');
            out.push({ label: txt(head), href: firstA ? firstA.getAttribute('href') : null, subs: subs, head: head });
        }
        return out;
    }

    /* A family heading over its own two column grid. The first
       child is the family's own All, which the heading covers. */
    function family(item, panel) {
        if (!item || !item.subs.length) return;
        var g = el('div', 'parcu-mm__group');
        g.appendChild(link(item.href, item.label, 'parcu-mm__grouplink'));
        panel.appendChild(g);
        var grid = el('div', 'parcu-mm__grid');
        item.subs.slice(1).forEach(function (s) {
            grid.appendChild(link(s.href, s.label, 'parcu-mm__sub'));
        });
        if (grid.children.length) panel.appendChild(grid);
    }

    /* Re-derive the one computed label. Idempotent, so running it
       on every mutation settles rather than looping. */
    function resync() {
        if (!live || !live.hoodBig) return;
        var want = shortLabel(txt(live.teeHead), txt(live.hoodHead));
        if (want && live.hoodBig.textContent !== want) live.hoodBig.textContent = want;
    }

    function build() {
        var root = document.getElementById('mobmenu');
        if (!root) return;
        if (root.getAttribute('data-parcu-menu')) { resync(); return; }
        var ul = root.querySelector('.menus ul');
        var quicks = root.querySelector('.quicks');
        if (!ul || !ul.children.length) return;
        var items = topItems(ul);
        if (items.length < 2) return;

        var tees = items[0];
        var hoods = items[1];
        /* The first child collection is the family's own All; the
           next two are the headline links. */
        var bigs = tees.subs.slice(1, 3);

        var wrap = el('div', 'parcu-mm');
        var panel = el('div', 'parcu-mm__panel is-on');

        var row = el('div', 'parcu-mm__row');
        var lead = el('div', 'parcu-mm__lead');
        bigs.forEach(function (s) { lead.appendChild(link(s.href, s.label, 'parcu-mm__big')); });

        var hoodBig = null;
        if (hoods.href) {
            hoodBig = link(hoods.href, shortLabel(tees.label, hoods.label), 'parcu-mm__big');
            lead.appendChild(hoodBig);
        }
        row.appendChild(lead);

        var side = el('div', 'parcu-mm__side');
        row.appendChild(side);
        panel.appendChild(row);

        /* The tee colours, then the hoodies, each under its own
           heading. The headline Hoodies link is the shortcut; this
           is the full family. */
        var teeRest = { label: tees.label, href: tees.href, subs: tees.subs.slice(2) };
        family(teeRest, panel);
        family(hoods, panel);

        /* Anything that is not a garment family becomes the quieter
           list at the foot of the sheet. */
        var foot = el('div', 'parcu-mm__foot');
        items.slice(2).forEach(function (it) {
            if (it.href) foot.appendChild(link(it.href, it.label, 'parcu-mm__footlink'));
            it.subs.forEach(function (s) { foot.appendChild(link(s.href, s.label, 'parcu-mm__footlink')); });
        });

        wrap.appendChild(panel);
        wrap.appendChild(foot);

        var host = root.querySelector('nav') || root;
        host.insertBefore(wrap, host.firstChild);

        /* The theme's own localization buttons are moved, not
           copied, so their existing handlers keep working. */
        if (quicks) {
            var sel = quicks.querySelectorAll('button.dropdown-caret');
            while (sel.length) { side.appendChild(sel[0]); sel = quicks.querySelectorAll('button.dropdown-caret'); }
        }

        live = { hoodBig: hoodBig, teeHead: tees.head, hoodHead: hoods.head };

        root.setAttribute('data-parcu-menu', '1');
        root.classList.add('parcu-mm-on');
    }

    function start() {
        build();
        if (!window.MutationObserver) return;
        var t;
        new MutationObserver(function () { clearTimeout(t); t = setTimeout(build, 60); })
            .observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else { start(); }
})();
